import React from 'react';
import TextLink from 'components/TextLink';
import { jsx as _jsx } from "react/jsx-runtime";
function HelixEmailLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(TextLink, {
    href: "mailto:helix@5app.com",
    children: children
  });
}
export default HelixEmailLink;